<q-comp-questionnaire-unavailable *ngIf="!questionnaireService.availableQuestionnaire; else available"></q-comp-questionnaire-unavailable>
<ng-template #available>

  <div class="container">
    <div class="row">
      <div class="col s12 page_title">
        <h1 class="q-police"><strong class="q-police-title">{{'Questionnaire'| trad}} : </strong><strong>{{'Myquestionnaires'| trad}}</strong></h1>
      </div>
    </div>
    <hr />
  </div>
  <div class="container">
    <div class="row">
      <h3 class="q-police" *ngIf="listQuestionnaire.stages.length > 0"> {{'Listofmyintern'| trad}} :</h3>
    </div>
    <div *ngIf="listQuestionnaire.stages" class="d-flex flex-row justify-content-around flex-wrap">
      <div class="col-12">
        <div *ngFor="let stage of listQuestionnaire.stages">
          <ng-container [ngTemplateOutlet]="stagelist" [ngTemplateOutletContext]="{stage:stage}"></ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="listQuestionnaire.stages.length == 0" class="d-flex flex-row justify-content-around flex-wrap">
      <div class="noData q-c-light-main">
        <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
        {{'NoStageQuest'|trad}}
      </div>
    </div>
  </div>
  <ng-template #stagelist let-stage='stage'>
    <button class="accordion accordionActive" (click)="accordion($event.target)">

      <div><strong>{{stage.numStage}}-</strong>{{stage.name}}</div>
      <div><i class="fas fa-calendar-alt"></i> : {{stage.dated}} {{'Au' | trad }} {{stage.datef}}</div>

    </button>
    <div class="panel" id="p{{stage.ident}}">
      <div class="questionnaire row" *ngFor="let questionnaire of stage.questionnaires" (click)="goTo(questionnaire.model, stage.ident, questionnaire.type,(questionnaire.isCertification && questionnaire.timed && questionnaire.timesUp)  )">

        <div class="col-sm-8"><label><b>{{'Answerthequestionnaire'| trad}} : </b>{{questionnaire.titre}}</label></div>
        <div class="col-sm-1  d-flex justify-content-center" [ngSwitch]="questionnaire.state">
          <span *ngSwitchCase="QuestionnaireState.Marked" class="badge badge-success  pt-2 pb-2  note " [ngClass]="questionnaire.questValid ? 'q-success' : 'q-warning'"> {{questionnaire.note}}/{{questionnaire.noteMax}}</span>
          <span *ngSwitchCase="QuestionnaireState.UnderCorrection" class="badge badge-success  pt-2 pb-2  note q-danger" title="Questionnaire en cours cotation"> <i class="fas fa-pencil-alt fa-lg"></i></span>
          <span *ngSwitchCase="QuestionnaireState.NoMark" class="badge badge-warning  pt-2 pb-2 note-none"> -/</span>
          <span *ngSwitchCase="QuestionnaireState.ContinueCertification" class="badge q-success  pt-2 pb-2 note" title="Continuer le questionnaire"><i class="fas fa-play"></i></span>
          <span *ngSwitchCase="QuestionnaireState.CertificationCompleted" class="badge q-danger  pt-2 pb-2 note" title="Certification fini"><i class="fas fa-lock"></i></span>
        </div>


        <div class="col-sm-2 d-flex justify-content-center badge--date">
          <span *ngIf="questionnaire.timeLocked" class="badge badge--date q-main  pt-2 pb-2  note ">{{questionnaire.unlockDate | DateBadge}}</span>
          <span *ngIf="!questionnaire.timeLocked" class="badge q-grey  badge--date pt-2 pb-2  note "> <i class="fas fa-eye"></i></span>         

        </div>

        <div class="col-sm-1 d-flex justify-content-center"><button *ngIf="questionnaire.note  && !questionnaire.isCertification" class="dlbtn hidden-btn q-c-main" [disabled]="disableDl" (click)="download(stage,questionnaire,$event)"><i class="fas fa-download"></i></button></div>
      </div>
    </div>
  </ng-template>
</ng-template>
